import PropTypes from 'prop-types';
import React from 'react';

import { SpaceRestrictionHandler } from '@confluence/space-base/entry-points/SpaceRestrictionHandler';

const SpaceRestriction = ({ spaceKey, contentId, children }) => {
	if (!spaceKey) {
		return children;
	}

	return (
		<SpaceRestrictionHandler spaceKey={spaceKey} contentId={contentId}>
			{children}
		</SpaceRestrictionHandler>
	);
};

SpaceRestriction.propTypes = {
	spaceKey: PropTypes.string,
	contentId: PropTypes.string,
	children: PropTypes.node.isRequired,
};

export default SpaceRestriction;
